import React, { Component } from 'react';
import PropTypes from "prop-types";
import "./ReportComment.css";
import { TextArea, Button, Intent } from "@blueprintjs/core";
import { withTranslation } from 'react-i18next';

import ReactModal from 'react-modal-resizable-draggable';

class ReportComment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reporter: "",
            comment: "",
            maxChart: 638,
            leftChart: 638,
            MaxLines: 11,
            lines: 11,
            lineExtension: 57,
            modalIsOpen: true,
        };

        //this.openModal = this.openModal.bind(this);
        //this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount = () => {
        const { reporter, comment, user } = this.props;
        //handleReporter(user.username);
        this.setState({ comment: comment, reporter: reporter, leftChart: this.state.maxChart - comment.length - 1 });
    }

    controlLineLength = (arrStr) => {
        let lineCorrect = true;
        arrStr.forEach(item => {
            if (item.length > this.state.lineExtension) {
                lineCorrect = false;
            }
        });
        return lineCorrect;
    }

    handleChange = (e) => {
        const { handleReportComment } = this.props;
        if (e.target.value.length <= this.state.maxChart - 1 &&
            e.target.value.split(/\r\n|\r|\n/).length <= this.state.MaxLines &&
            this.controlLineLength(e.target.value.split(/\r\n|\r|\n/))) 
        {
            this.setState({
                comment: e.target.value,
                leftChart: this.state.maxChart - e.target.value.length - 1,
                lines: e.target.value.split(/\r\n|\r|\n/).length
            });
            handleReportComment(e.target.value);
        }
    }

    handleReporter = (e) => {
        const { handleReporter } = this.props;
        this.setState({ reporter: e.target.value });
        handleReporter(e.target.value);
    }

    //openModal() {
    //    this.setState({ modalIsOpen: true });
    //}

    //closeModal() {
    //    this.setState({ modalIsOpen: false });
    //}

    handlePrintReport = () => {
        const { handleReportPDF, closeModal } = this.props;
        handleReportPDF();
        closeModal();
    }

    render() {
        const {
            modalIsOpen,
            closeModal,
            t
        } = this.props;

        return (

            <ReactModal
                initWidth={600}
                initHeight={400}
                onFocus={() => console.log("Modal is clicked")}
                className={"modalclass"}
                onRequestClose={closeModal}
                isOpen={modalIsOpen}
                disableKeystroke={"true"}>
                <h3>{t("Report Comments")}</h3>
                <div className="content">
                    <div className="reporter">
                        <span> {t("Creator: ")} </span>
                        <input className="bp4-fill" type="text" placeholder="Reporter name" value={this.state.reporter} onChange={this.handleReporter} dir="auto" />
                    </div>
                    <TextArea className="textarea"

                        growVertically={true}

                        onChange={this.handleChange}
                        value={this.state.comment}
                    />
                    <div className="leftChart">
                        <span> {t("Characters left: ")} {this.state.leftChart}  </span>
                        <br />
                        <span> {t("Line Changes: ")} {this.state.lines}/{this.state.MaxLines}   </span>
                    </div>
                    <div className="actionButtonDiv">
                        <Button className="actionButton" icon={"cross"} onClick={closeModal}> {t("Close")} </Button>
                        <Button className="actionButton" icon={"print"} onClick={this.handlePrintReport}> {t("Print")} </Button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(ReportComment)

ReportComment.propTypes = {

};
            